// extracted by mini-css-extract-plugin
export default {"button":"styles_button__cLVM3","bn":"styles_bn__dfNjP","disabled":"styles_disabled__GZrd+"};